import { useEffect, useState } from "react";
import { useProjectContext } from "@contexts/projects";
import { fetchCostOriginTitles } from "./costOriginApi";
import AnnulledTitlesList from "./AnnulledTitlesList";

// Aviso discreto "N título(s) anulado(s) na Ampli · R$ X a pagar fora da conta · Ver".
// Entrada: `activeProject.titleAnnulments` ({count, removedToPay, removedPaid,
// fromMeasurement} | null; valores em REAIS). Some com resumo nulo ou count 0.
// Não usar <span> para o texto: o reset de _fonts.scss:17 zera todo span dentro de .card.
// "Ver" abre um modal em leitura com os `annulled[]` de costOriginTitles (por obra,
// independente do balde -- pedimos "finance" com pageSize 1 só para obter a lista).

const brl = (value) => Number(value || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const noticeText = ({ count, removedToPay }) =>
  `${count} ${count === 1 ? "título anulado" : "títulos anulados"} na Ampli · ${brl(removedToPay)} a pagar fora da conta`;

const AnnulmentsModal = ({ projectId, onClose }) => {
  const [state, setState] = useState({ status: "loading", annulled: [] });
  useEffect(() => {
    let cancelled = false;
    fetchCostOriginTitles(projectId, { bucket: "finance", page: 0, pageSize: 1 }).then((data) => {
      if (cancelled) return;
      if (!data) setState({ status: "error", annulled: [] });
      else setState({ status: "ready", annulled: data.annulled ?? [] });
    });
    return () => { cancelled = true; };
  }, [projectId]);
  return (
    <div className="offcanvas active" role="dialog" aria-modal="true" aria-label="Anulados na Ampli">
      <div className="offcanvas-container large">
        <hgroup className="offcanvas-header">
          <h2>Anulados na Ampli</h2>
          <button onClick={onClose} aria-label="Fechar">
            <i className="icon icon-width-24 icon-times background-accent" aria-hidden={true}></i>
          </button>
        </hgroup>
        <div className="offcanvas-content">
          {state.status === "loading" && <p className="card-label margin-top-16">Carregando…</p>}
          {state.status === "error" && (
            <p className="empty-state margin-top-16">Não foi possível carregar os títulos anulados.</p>
          )}
          {state.status === "ready" && state.annulled.length === 0 && (
            <p className="empty-state margin-top-16">Nenhum título anulado.</p>
          )}
          {state.status === "ready" && <AnnulledTitlesList annulled={state.annulled} />}
        </div>
      </div>
      <div onClick={onClose} className="offcanvas-background" />
    </div>
  );
};

const TitleAnnulmentNotice = ({ summary }) => {
  const { activeProject } = useProjectContext();
  const [open, setOpen] = useState(false);
  if (!summary || !(summary.count > 0)) return null;
  return (
    <>
      <p className="title-annulment-notice card-label margin-top-8" role="note">
        {noticeText(summary)}{" · "}
        <button type="button" className="button button-accent small" onClick={() => setOpen(true)}>Ver</button>
      </p>
      {open && <AnnulmentsModal projectId={activeProject?._id} onClose={() => setOpen(false)} />}
    </>
  );
};

export default TitleAnnulmentNotice;
